import { PaddedSurface as Surface } from "App/global-style";
import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { VALUE_TYPE } from "Components/NumberValue";
import { useTexts } from "Components/TextContext";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { ProductPriceFormValue } from "../../valuablesInterface";

interface Props {
  formProps: FormikProps<ProductPriceFormValue>;
  updatePrices: (coverageAmount: number | undefined) => void;
}

export const ValuablesProductPriceFormElements = (
  props: Props,
): React.ReactElement => {
  const { formProps, updatePrices } = props;
  const { getText } = useTexts();

  return (
    <Surface>
      <NumericInput
        id="coverage_amount"
        name="coverage_amount"
        label={getText("valuablesform.label.coverage_amount")}
        hint={getText("valuablesform.hint.coverage_amount")}
        inputMode={InputMode.NUMERIC}
        suffix={VALUE_TYPE.NOK}
        onChange={(values) => updatePrices(values.floatValue)}
        error={getError("coverage_amount", formProps)}
        large
      />
    </Surface>
  );
};
